import { filter, map, Observable } from 'rxjs';
import { Injectable, InjectionToken, EnvironmentProviders, makeEnvironmentProviders, inject } from '@angular/core';
import { Resource } from 'app/models/resource.model';
import { PusherMessage, PusherService, SoketiConfigInterface } from 'app/modules/common/services/pusher.service';

export const PUSHER_RESOURCES_CONFIG = new InjectionToken<PusherResourcesConfigInterface>('PUSHER_RESOURCES_CONFIG');

export interface PusherResourcesConfigInterface extends SoketiConfigInterface {
  channel: string;
}

@Injectable({
  providedIn: 'root',
})
export class PusherResourcesService {
  private readonly _pusherService = inject(PusherService);
  private readonly _config = inject<PusherResourcesConfigInterface>(PUSHER_RESOURCES_CONFIG);

  resourceUpdatedEvent: string = 'message';

  readonly updates$: Observable<PusherMessage> = this._pusherService.soketiStream(this._config, this._config.channel, [
    this.resourceUpdatedEvent,
  ]);

  updatesForResource(resourceId: string): Observable<Resource> {
    return this.updates$.pipe(
      filter((msg: PusherMessage) => msg.event === this.resourceUpdatedEvent && msg.data?.id === 'update.resource'),
      map(
        (msg: PusherMessage) =>
          (typeof msg.data.data === 'string' ? JSON.parse(msg.data.data) : msg.data.data) as Resource,
      ),
      filter((resource: Resource) => resource.id === resourceId),
    );
  }
}

export const providePusherResources = (config: PusherResourcesConfigInterface): EnvironmentProviders =>
  makeEnvironmentProviders([PusherResourcesService, { provide: PUSHER_RESOURCES_CONFIG, useValue: config }]);

export const providePusherResourcesTest = (): EnvironmentProviders =>
  providePusherResources({
    id: '123456789',
    wsHost: 'dev-soketi.fluidnext.com',
    forceTLS: true,
    cluster: 'mt1',
    channel: 'private-backoffice-resources',
  });
